import React, { useState, useCallback, useContext, useRef, useEffect } from 'react'//,{useState,useCallback}
import { useTranslation } from "react-i18next";
import styles from './AgentsSettings.module.css'
import { DropdownButton, Dropdown, Button } from 'react-bootstrap'
import * as loginReq from '../../../../axios/requests/loginReq'
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import AgentList from '../../ChatSettings/AgentList'

// import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'//SettingsDropDown
// import SettingsTextBox from '../../../UI/SettingsTextBox/SettingsTextBox'




const AgentsSettings = (props) => {
    const [t] = useTranslation('common')
    const defaultAgentDropDownItems = t('Select agent')
    const [selectedAgentState, setSelectedAgentState] = useState(defaultAgentDropDownItems)
    const alertCtx = useContext(AlertContext)
    const [dropdownAgentsOpen, setDropdownAgentsOpen] = useState(false)
    const dropdownRef = useRef(null)
    // const [selectedAgentPermissionState,setSelectedAgentPermissionState] = useState(9)

    const handleOnAgentSelect = useCallback((agentName, permission) => {
        setSelectedAgentState(agentName)
        setDropdownAgentsOpen(false)
        // setSelectedAgentPermissionState(permission)
    }, [])

    //useCallback functions
    const handleOnAgentLogOutClicked = useCallback(async () => {
        if (selectedAgentState === defaultAgentDropDownItems) {
            // alert('.נא לבחור נציג')
            alertCtx.showAlert(t('error'), t('Please select agent'), 'sm')
        }
        else {
            let msg = await loginReq.disconnectSpecificAgent(selectedAgentState)
            alertCtx.showAlert(t('success'), msg, 'sm')
            // alert(msg)
        }
    }, [selectedAgentState, alertCtx])

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownAgentsOpen(false)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    // const setSettings = props.setSettings
    // const handleOnCustomCollectionSettingsChange = useCallback((settingType, settingName, value) => {
    //     if (settingType === 'onUserTabel') {
    //         if (settingName === 'userPermission') {
    //             if (value === 'regularUser') {
    //                 value = 9
    //             }
    //             else {
    //                 value = 3
    //             }
    //             setSelectedAgentPermissionState(value)
    //             const newValue = {
    //                 agent: selectedAgentState,
    //                 permissionType: value
    //             }
    //             setSettings(settingType, settingName, newValue)
    //         }
    //     }
    // }, [setSettings, selectedAgentState])
    const agentList = props.agentsList.map(agent => (
        <AgentList
            userId={agent._id}
            avatarImg={props.avatarImg}
            key={agent.agentName}
            permissionType={props.permissionType}
            // groupSetting={props.groupSetting}
            // loggedAgent_groupList={props.agent_groupList}
            listOfOnlineAgents={props.listOfOnlineAgents}
            onClick={handleOnAgentSelect}
            agentItemGroupList={agent.groupList}
            agentItemAgentName={agent.agentName}
            agentItemAvatarName={agent.avatarName}
            name={agent.name}
        >
        </AgentList>
    ));

    // let permissionTypeName = undefined
    // if (selectedAgentPermissionState > 3) {
    //     permissionTypeName = 'regularUser'
    // }
    // else {
    //     permissionTypeName = 'admin'
    // }

    // let permissionTypeNameItems = ['regularUser', 'admin']

    return (
        <section className={styles.SettingsSection}>
            <div >
                <h2 className={styles.settingsTitle}>{t('Agent management')} :</h2>
                <div className={styles.someSettingDiv} ref={dropdownRef}>

                    <span className={styles.specificSettingsText}>{t('Select agent')} : </span>
                    <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={selectedAgentState} show={dropdownAgentsOpen} onClick={() => setDropdownAgentsOpen(!dropdownAgentsOpen)}>
                        {agentList}
                    </DropdownButton>
                    {
                        selectedAgentState !== defaultAgentDropDownItems &&
                        <Button className={styles.logoutAgent} variant='danger' onClick={handleOnAgentLogOutClicked}>{t('Disconnect')}</Button>
                    }
                </div>
                {/* {selectedAgentState !== defaultAgentDropDownItems &&
                    <Fragment>
                        <SettingsDropDown nowSelected={permissionTypeName} setSettings={handleOnCustomCollectionSettingsChange} settingType={'onUserTabel'} label={'userPermission'} settingName={'userPermission'} items={permissionTypeNameItems} />
                    </Fragment>} */}
            </div>
        </section >
    )
}

export default AgentsSettings
